// extracted by mini-css-extract-plugin
module.exports = {"root":"Signin_root___jR0E","contentContainer":"Signin_contentContainer__1LHDG","placeholder_container":"Signin_placeholder_container__3x7KC"};